// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'kt-info-entity-dialog',
	templateUrl: './info-entity-dialog.component.html',
	styleUrls: ['./info-entity-dialog.component.scss']
})
export class InfoEntityDialogComponent implements OnInit {
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<InfoEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<InfoEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
	}

	/**
	 * Close dialog
	 */
	onOkClick(): void {
		this.dialogRef.close(true);
	}
}
